// Mock data for Atlético South Florida
// NOTE: This data is mocked for the frontend teaser. Registration submissions
// are saved to localStorage in this phase and will later be wired to the backend.

export const club = {
  name: "Atlético South Florida",
  shortName: "Atlético SoFlo",
  tagline: "Black · Gold · Ambition",
  crest: "/logo.png",
  email: "info@atleticosoflo.com",
  instagram: "@atletico_soflo",
  location: "South Florida, USA",
};

export const heroImages = {
  main: "https://images.unsplash.com/photo-1560272564-c83b66b1ad12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxzb2NjZXIlMjBhY3Rpb258ZW58MHx8fHwxNzg1MzY1MjM0fDA&ixlib=rb-4.1.0&q=85",
  youth: "https://images.unsplash.com/photo-1626248801379-51a0748a5f96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHx5b3VuZyUyMGFkdWx0JTIwbWVuJTIwc29jY2VyJTIwbWF0Y2glMjBjb21wZXRpdGl2ZXxlbnwwfHx8fDE3ODUzODI4MDZ8MA&ixlib=rb-4.1.0&q=85",
  celebrate: "https://images.pexels.com/photos/38602682/pexels-photo-38602682.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  celebrateAlt: "https://images.pexels.com/photos/3319180/pexels-photo-3319180.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  stadium: "https://images.unsplash.com/photo-1599158150601-1417ebbaafdd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxzdGFkaXVtJTIwbmlnaHR8ZW58MHx8fHwxNzg1MzY1MjM0fDA&ixlib=rb-4.1.0&q=85",
};

export const stats = [
  { value: "18+", label: "Young Adults" },
  { value: "Pro", label: "Pathway" },
  { value: "College", label: "Exposure" },
  { value: "2026", label: "Founded" },
];

export const aboutCards = [
  {
    title: "Elite Training",
    body: "High-performance coaching focused on technical sharpness, tactical intelligence and a professional mentality.",
    icon: "Dumbbell",
  },
  {
    title: "South Florida Identity",
    body: "A competitive club built on local pride, ambition, and a relentless winning mindset.",
    icon: "Sun",
  },
  {
    title: "Pathway to Pro & College",
    body: "Real exposure and support for young adults chasing college scholarships and the professional game.",
    icon: "GraduationCap",
  },
];

export const programs = [
  { title: "Competitive Squad", tag: "First Team", icon: "Shield", desc: "A serious, competitive environment for young adults ready to test themselves at the highest level." },
  { title: "College Pathway", tag: "Recruitment", icon: "GraduationCap", desc: "Showcases, highlight support and guidance to help players earn college roster spots and scholarships." },
  { title: "Professional Pathway", tag: "Next Level", icon: "Trophy", desc: "Trial preparation, scouting exposure and connections for players targeting the professional ranks." },
  { title: "Elite Training", tag: "Performance", icon: "Dumbbell", desc: "High-intensity technical and tactical sessions built around a professional standard of preparation." },
  { title: "Match Play & Fixtures", tag: "Competition", icon: "Flag", desc: "Regular competitive fixtures against strong opposition to sharpen game intelligence and edge." },
  { title: "Showcase & Camps", tag: "Exposure", icon: "Star", desc: "Seasonal showcase events and camps designed to put players in front of scouts and coaches." },
];

export const coaches = [
  { img: "/team/c3_round.png", name: "Alan Saranga", role: "Team Manager & Pathway Director" },
  { img: "/team/c2_round.png", name: "Derick Pearlin", role: "Team Manager & Program Director" },
  { img: "/team/c1_round.png", name: "Mike Alvarez", role: "Head Coach" },
];

export const schedule = [
  { day: "Tuesday", time: "7:30 PM – 9:30 PM", type: "Training" },
  { day: "Thursday", time: "7:30 PM – 9:30 PM", type: "Training" },
  { day: "Weekend", time: "Match Day Fixtures", type: "Match" },
];

export const gallery = [
  { src: "/photos/1st-game-full-team.jpeg", caption: "1st Game — Full Team" },
  { src: "/photos/warm-up-before-game.jpeg", caption: "Warm Up Before Game" },
  { src: "/photos/starters-game-1.jpeg", caption: "Starters — Game 1, Spring 2026" },
  { src: "/photos/team-huddle.jpeg", caption: "Team Huddle" },
  { src: "/photos/starters-game-3.jpeg", caption: "Starters — Game 3, Spring 2026" },
  { src: "/photos/tryouts.jpeg", caption: "Tryouts" },
];

export const news = [
  {
    id: 1,
    date: "July 12, 2025",
    category: "Club",
    title: "Atlético South Florida Opens 2025 Tryout Registration",
    excerpt: "The club officially opens tryout registration for its competitive young adult squad.",
    img: "/photos/tryouts.jpeg",
  },
  {
    id: 2,
    date: "July 5, 2025",
    category: "Match Report",
    title: "Strong Team Performance in Spring 2026 Fixtures",
    excerpt: "A disciplined, competitive display as the club builds momentum this season.",
    img: "/photos/starters-game-3.jpeg",
  },
  {
    id: 3,
    date: "June 28, 2025",
    category: "Pathway",
    title: "Players Earn College Showcase Invitations",
    excerpt: "Several squad members receive invites to upcoming college recruitment showcases.",
    img: "/photos/warm-up-before-game.jpeg",
  },
];

export const playingLevels = [
  "High School",
  "College",
  "Semi-Professional",
  "Amateur / Club",
  "Other",
];

export const positions = [
  "Goalkeeper",
  "Defender",
  "Midfielder",
  "Forward",
  "Undecided",
];
